/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".footer[_ngcontent-%COMP%]{padding:1.5625rem 0 2.375rem;text-align:center}.footer__content[_ngcontent-%COMP%]{display:flex;height:1.25rem;justify-content:center;font-size:.875rem}.footer__link[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center}.footer__logo[_ngcontent-%COMP%]{color:#000028;margin-left:.625rem}@media (min-width:48em){.footer[_ngcontent-%COMP%]{padding:3.125rem 0 6.25rem}}"];
export { styles as styles };
